import { render, staticRenderFns } from "./SHS_1_Code.vue?vue&type=template&id=6502924f&"
import script from "./SHS_1_Code.vue?vue&type=script&lang=js&"
export * from "./SHS_1_Code.vue?vue&type=script&lang=js&"
import style0 from "./SHS_1_Code.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports